"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleLoader = exports.FlowerLoader = exports.ButterflyLoader = void 0;
var react_1 = __importDefault(require("react"));
var Constants = __importStar(require("./constants"));
var style_1 = require("./style");
var Butterfly_1 = __importDefault(require("./Butterfly"));
var Flower_1 = __importDefault(require("./Flower"));
var Circle = function (_a) {
    var height = _a.height, variant = _a.variant, width = _a.width;
    return (react_1.default.createElement(style_1.CircleSvg, { height: height, viewBox: '0 0 50 50', width: width },
        react_1.default.createElement(style_1.StyledCircle, { cx: '25', cy: '25', r: '20', variant: variant })));
};
var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Loader.prototype.render = function () {
        var _a = this.props, className = _a.className, icon = _a.icon, height = _a.height, variant = _a.variant, width = _a.width;
        return (react_1.default.createElement(style_1.LoaderContainer, { className: className, height: height, width: width },
            ((icon === Constants.LOADER_ICON_BUTTERFLY)
                ? (react_1.default.createElement(Butterfly_1.default, { height: height, variant: variant, width: width }))
                : null),
            ((icon === Constants.LOADER_ICON_FLOWER)
                ? (react_1.default.createElement(Flower_1.default, { height: height, variant: variant, width: width }))
                : null),
            react_1.default.createElement(Circle, { height: height, variant: variant, width: width })));
    };
    Loader.defaultProps = {
        height: '3rem',
        width: '3rem'
    };
    return Loader;
}(react_1.default.PureComponent));
var ButterflyLoader = function () { return (react_1.default.createElement(Loader, { icon: Constants.LOADER_ICON_BUTTERFLY })); };
exports.ButterflyLoader = ButterflyLoader;
var FlowerLoader = function () { return (react_1.default.createElement(Loader, { icon: Constants.LOADER_ICON_FLOWER })); };
exports.FlowerLoader = FlowerLoader;
var SimpleLoader = function () { return (react_1.default.createElement(Loader, { variant: Constants.LOADER_VARIANT_ALT })); };
exports.SimpleLoader = SimpleLoader;
__exportStar(require("./types"), exports);
exports.default = Loader;
